import {
  createBrowserRouter,
  createHashRouter,
  Navigate,
  Outlet,
} from "react-router-dom";
import Layout from "./components/layout";
import { ErrorFallback } from "./components/layout/errors/fallback";
import DeployBlocker from "./components/layout/DeployBlocker";
import Home from "./pages/home";
import Login from "./pages/login";
import Signup from "./pages/signup";
import Competition from "./pages/competition";
import NoneNaviLayout from "./components/layout/none-navi-layout";
import CompetitionDetail from "./pages/competition/detail";
import CompetitionApply from "./pages/competition/apply";
import CompetitionStatus from "./pages/competition/status";
import CompetitionRanking from "./pages/competition/ranking";
import Setting from "./pages/setting";
import SettingInfo from "./pages/setting/info";
import SettingInfoEdit from "./pages/setting/info/edit";
import SettingInfoEmail from "./pages/setting/info/email";
import PublicOnlyRoute from "./routes/PublicOnlyRoute";
import WithDraw from "./pages/withdraw";
import Privacy from "./pages/privacy";
import CompetitionHistory from "./pages/setting/info/competition-history";
import PaymentHistory from "./pages/setting/info/payment-history";
import CompetitionHistoryDetail from "./pages/setting/info/competition-history-detail";
import CompetitionApplyCancel from "./pages/setting/info/competition-apply-cancel";
import Community from "./pages/community";
import Notice from "./pages/notice/index";
import NoticeDetail from "./pages/notice/detail";
import StoreDetail from "./pages/store/detail";
import Search from "./pages/search/index";
import Alarm from "./pages/alarm/index";
import CommunityDetail from "./pages/community/detail";
import CommunityFormPage from "./pages/community/form";
import ScoreDetailPage from "./pages/score/detail";
import Score from "./pages/score";
import ScoreFormPage from "./pages/score/form";
import ReservationAdd from "./pages/reservation/add";
import ReservationHistory from "./pages/setting/info/reservation-history";
import ReservationCancel from "./pages/setting/info/reservation-cancel";
import Reservation from "./pages/reservation";
import ReservationHistoryDetail from "./pages/setting/info/reservation-history-detail";
import ReservationHistoryCancel from "./pages/setting/info/reservation-history-cancel";
import PaymentCompletePage from "./pages/payment/complete";
import TournamentPaymentCompletePage from "./pages/payment/tournament-complete";
import TournamentApplyCompletePage from "./pages/payment/tournament-apply-complete";
import AppOpen from "./pages/app-open";
import AppLink from "./pages/app-link";
import OptionalTermsSettingsPage from "./pages/setting/info/OptionalTermsSettingsPage";

function RootLayout() {
  return (
    <>
      <DeployBlocker />
      <Outlet />
    </>
  );
}

const useHash = import.meta.env.VITE_USE_HASH_ROUTER === "true";

const routes = [
  {
    element: <RootLayout />,
    children: [
      {
        errorElement: <ErrorFallback />,
        children: [
          {
            element: <Layout />,
            children: [
              { index: true, element: <Home /> },
              { path: "competition", element: <Competition /> },
              { path: "setting", element: <Setting /> },
              { path: "community", element: <Community /> },
              // 예약 임시 페이지
              { path: "reservation", element: <Reservation /> },
              // { path: "reservation/golf-info", element: <ReservationGolfInfo/>},
              // { path: "reservation/list", element: <ReservationList/>},
              // { path: "reservation/:id", element: <ReservationDetail/>},
              // { path: "reservation/:id/payment", element: <ReservationPayment/>},
              // { path: "reservation/:id/done", element: <ReservationDone/>},
              // { path: "reservation/my-info/:id", element: <ReservationMyInfo/>},
              { path: "score", element: <Score /> },
            ],
          },
          {
            element: <NoneNaviLayout />,
            children: [
              { path: "competition/:id", element: <CompetitionDetail /> },
              { path: "competition/:id/apply", element: <CompetitionApply /> },
              {
                path: "competition/:id/status",
                element: <CompetitionStatus />,
              },
              {
                path: "competition/:id/ranking",
                element: <CompetitionRanking />,
              },
              { path: "community/:id", element: <CommunityDetail /> },
              { path: "community/add", element: <CommunityFormPage /> },
              { path: "community/edit/:id", element: <CommunityFormPage /> },
              { path: "setting/info", element: <SettingInfo /> },
              { path: "setting/info/edit", element: <SettingInfoEdit /> },
              { path: "setting/info/email", element: <SettingInfoEmail /> },
              {
                path: "setting/tournament-history",
                element: <CompetitionHistory />,
              },
              {
                path: "setting/tournament-history/:id/:applyId",
                element: <CompetitionHistoryDetail />,
              },
              {
                path: "setting/tournament-history/:id/:applyId/cancel",
                element: <CompetitionApplyCancel />,
              },
              { path: "setting/payment-history", element: <PaymentHistory /> },
              { path: "withdraw", element: <WithDraw /> },
              { path: "privacy", element: <Privacy /> },
              { path: "notice", element: <Notice /> },
              { path: "notice/:id", element: <NoticeDetail /> },
              { path: "store/:id", element: <StoreDetail /> },
              { path: "search", element: <Search /> },
              { path: "alarm", element: <Alarm /> },
              { path: "score/:id", element: <ScoreDetailPage /> },
              { path: "score/add", element: <ScoreFormPage /> },
              { path: "reservation/add", element: <ReservationAdd /> },
              {
                path: "setting/reservation-history",
                element: <ReservationHistory />,
              },
              {
                path: "setting/reservation-history/:id",
                element: <ReservationHistoryDetail />,
              },
              {
                path: "setting/reservation-history-cancel/:id",
                element: <ReservationHistoryCancel />,
              },
              {
                path: "setting/reservation-history/:id/cancel",
                element: <ReservationCancel />,
              },
              {
                path: "setting/optional-terms",
                element: <OptionalTermsSettingsPage />,
              },

              //   결제 확인용 임시 페이지
              {
                path: "payment/:id/complete",
                element: <PaymentCompletePage />,
              },
              {
                path: "tournament-payment/:id/complete",
                element: <TournamentPaymentCompletePage />,
              },
              // 무통장입금 접수 완료
              {
                path: "tournament-apply/:applyId/complete",
                element: <TournamentApplyCompletePage />,
              },
            ],
          },
        ],
      },
      {
        element: <PublicOnlyRoute />,
        errorElement: <ErrorFallback />,
        children: [
          {
            element: <NoneNaviLayout />,
            children: [
              { path: "login", element: <Login /> },
              { path: "signup", element: <Signup /> },
              { path: "privacy", element: <Privacy /> },
            ],
          },
        ],
      },
      {
        path: "app-open",
        element: <AppOpen />,
      },
      // 알림톡 버튼 진입 전용 (앱 실행 / 스토어 이동 분기)
      {
        path: "app-link",
        element: <AppLink />,
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  },
];

export const router = useHash
  ? createHashRouter(routes) // #/about
  : createBrowserRouter(routes); // /about
